import {isAgentSystemUserMessage} from './systemChatMessages';

export const getMessageText = (message) => {
  if (!message) return '';

  let text = '';

  if (message.parts?.length) {
    text = message.parts
      .filter((part) => part.type === 'text')
      .map((part) => part.text)
      .join('');
  } else {
    text = message.content || '';
  }

  if (message.role === 'user' && isAgentSystemUserMessage(text)) {
    return '';
  }

  return text;
};
